
import { useGetMessagesQuery, useGetEntitiesByFieldQuery, useAddEntityMutation, useUpdateMessagesReadMutation } from '../../services/gamebox';
import { useParams, Link } from "react-router-dom";
import useLocalStorage from '../../hooks/useLocalStorage';
import './Chat.css'
import profileImg from './profile.png'
import { useState, useRef, useEffect } from 'react';
import {Button} from 'react-bootstrap';

const getAvatar = (Player) => {
    return (<img src={profileImg} alt="avatar" />)
}

export default function Chat() {    
  const gameroomCode = JSON.parse(localStorage.getItem('user')).room;
  const [selectedPlayer, setselectedPlayer] = useState(null)
  const [user, setUser] = useLocalStorage("user", "");
  const { data: gameroom } = useGetEntitiesByFieldQuery({ name: 'gameroom', field: 'join_code', value: gameroomCode })
  const { data: player } = useGetEntitiesByFieldQuery({ name: 'player', field: 'id', value: user.user.id })

  const [addMessage] = useAddEntityMutation()
  const [updateMessages] = useUpdateMessagesReadMutation()
  const [messageText, setMessageText] = useState('')

  const sendMessage = () => {
    addMessage({ name: 'message', body: { data: { gameroom: gameroom.data[0].id, message_type: 'CHAT', message: messageText, to_player: selectedPlayer.id, from_player: player.data[0].id } } })
    setMessageText('')
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      sendMessage()
    }
  }

  const onPlayerChange = (splayer) => {
    setselectedPlayer(splayer)
    //update all messages to be read from this player
    updateMessages({body:{ data: {from_player: splayer.id, to_player: player.data[0].id}}})
  }

  return (
    < div className="container" >
      <div className="row clearfix">
        <div className="col-lg-12">
          <div className="card chat-app">
            {gameroom && player && <PlayerList gameroomId={gameroom.data[0].id} onPlayerChange={onPlayerChange} myPlayer={player.data[0]} />}
            <div className="chat">
              <div className="chat-header clearfix">
                <div className="row">
                  <div className="col-lg-6">
                    <a href="" data-toggle="modal" data-target="#view_info">
                      {selectedPlayer && getAvatar(selectedPlayer)}
                    </a>
                    <div className="chat-about">
                      <h6 className="m-b-0">{selectedPlayer && selectedPlayer.attributes.name}</h6>                      
                    </div>
                  </div>
                  <div className="col-lg-6 hidden-sm text-right">
                      <Link to={`/gameroom`}><Button className="btn btn-secondary">Close</Button></Link>
                  </div>
                </div>
              </div>
              <div className="chat-history">
                {selectedPlayer && player && gameroom && <Messages gameroomId={gameroom.data[0].id} selectedPlayer={selectedPlayer} myPlayer={player.data[0]} />}
              </div>
              <div className="chat-message clearfix">
                <div className="input-group mb-0">
                  <input type="text" className="form-control" value={messageText} placeholder="Enter text here..." onChange={(e) => { setMessageText(e.target.value) }} onKeyDown={handleKeyDown} />
                  <div className="btn btn-outline-secondary" onClick={sendMessage}>
                    <i className="fa fa-send"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export function Messages(props) {
  const { selectedPlayer, myPlayer, gameroomId } = props
  const { data: messages } = useGetMessagesQuery(gameroomId)
  const [updateMessages] = useUpdateMessagesReadMutation()

  const getMessageRender = (message) => {
    if (!message.attributes.from_player) return
    if (message.attributes.from_player.data.id === selectedPlayer.id && message.attributes.to_player.data.id === myPlayer.id) {
      return (
        <li className="clearfix" key={message.id}>
          <div className="message-data">
            <span className="message-data-time">{new Date(message.attributes.createdAt).toLocaleTimeString('en-us', {hour: '2-digit', minute: '2-digit'})}</span>
          </div>
          <div className="message my-message">{message.attributes.message}</div>
        </li>
      )
    }
    if (message.attributes.from_player.data.id === myPlayer.id && message.attributes.to_player.data.id === selectedPlayer.id) {
      return (
        <li className="clearfix" key={message.id}>
          <div className="message-data text-right">
            <span className="message-data-time">{new Date(message.attributes.createdAt).toLocaleTimeString('en-us', {hour: '2-digit', minute: '2-digit'})}</span>
            {getAvatar(myPlayer)}
          </div>
          <div className="message other-message float-right">{message.attributes.message}</div>
        </li>
      )
    }
  }

  const messagesEndRef = useRef(null)

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  useEffect(() => {
    scrollToBottom()
    //messages are read after rendering
    updateMessages({body:{ data: {from_player: selectedPlayer.id, to_player: myPlayer.id}}})
  }, [messages]);

  return (
    <>
      <ul className="m-b-0">
        {
          (messages && messages.data.map((message) =>
            getMessageRender(message)
          ))
        }
      </ul>
      <div ref={messagesEndRef} />
    </>
  )
}

export function PlayerList(props) {
  const { gameroomId, onPlayerChange, myPlayer } = props
  const [selectedPlayer, setselectedPlayer] = useState(null)
  const { data: players } = useGetEntitiesByFieldQuery({ name: 'player', field: 'gameroom', value: gameroomId, relation: 'id', populate: '*' })

  useEffect(() => {
    if (players && players.data && selectedPlayer == null) {
      const firstPlayer = players.data.filter((p)=> p.id !== myPlayer.id)[0]
      setselectedPlayer(firstPlayer)
      onPlayerChange(firstPlayer)
    }
  }, [players]);  

  return (
    <div id="plist" className="people-list">

      <ul className="list-unstyled chat-list mt-2 mb-0">
        {selectedPlayer && players && players.data.map((Player) => {
          if(Player.id === myPlayer.id) return
          return (
            <li key={Player.id} className={`clearfix ${(Player.id === selectedPlayer.id) ? 'active' : ''}`} onClick={() => { setselectedPlayer(Player); onPlayerChange(Player) }}>
              {getAvatar(Player)}
              <div className="about">
                <div className="name">{Player.attributes.name}</div>
              </div>
            </li>
          )
        }
        )}
      </ul>
    </div>
  )
}